'use client';

import Modal from './Modal';
import Button from './Button';
import { type ReactNode, type RefObject } from 'react';
import { type VariantProps } from 'class-variance-authority';
import { buttonVariants } from '~/components/ui/button';
import { cn } from '~/lib/utils';

export interface ConfirmationModalProps {
  modalRef: RefObject<HTMLDialogElement | null>;
  onClose: () => void;
  onConfirm: () => void;
  header: string;
  message: ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
  /** @deprecated Prefer confirmVariant */
  confirmButtonClass?: string;
  confirmVariant?: VariantProps<typeof buttonVariants>['variant'];
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
}

export default function ConfirmationModal({
  modalRef,
  onClose,
  onConfirm,
  header,
  message,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  confirmButtonClass,
  confirmVariant = 'destructive',
  isLoading = false,
  disabled = false,
  className = 'max-w-md',
}: ConfirmationModalProps) {
  return (
    <Modal
      ref={modalRef}
      onClose={onClose}
      header={header}
      subHeader={message}
      className={className}
      footer={
        <>
          <Button size="sm" variant="outline" label={cancelLabel} onClick={onClose} type="button" />
          <Button
            label={confirmLabel}
            onClick={onConfirm}
            size="sm"
            variant={confirmVariant}
            className={cn(confirmButtonClass)}
            type="button"
            disabled={disabled || isLoading}
            isLoading={isLoading}
          />
        </>
      }
    />
  );
}
